import { useEffect } from 'react';

import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';

import { useStore } from '@modules';

export const FingerPrintInit: CustomFC = () => {
  const [{ global, login }] = useStore();
  const { calcId } = global;
  const { isLoggedIn } = login;

  const { getData } = useVisitorData({ tag: { calcId } }, { immediate: false });

  useEffect(() => {
    if (calcId && isLoggedIn) getData();
  }, [calcId, isLoggedIn]);

  return null;
};

export default FingerPrintInit;
